export function getLocalStorageValue(key: string, defaultValue: unknown = null) {
  const savedItem = localStorage.getItem(key);
  if (savedItem) {
    return JSON.parse(savedItem);
  }
  return defaultValue;
}
